// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PieCard_wrapper__5ia0C"};